import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  login_nav_container: {
    padding: 0,
  },
  login_container: {
    display: "flex",
    justifyContent: "center",
    margin: "auto",
    width: "100%",
    minHeight: "85vh",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "#f5f7fa",
  },
  login_form_container: {
    position: "relative",
    display: "flex",
    borderRadius: "16px",
    width: "400px",
    alignItems: "center",
    flexDirection: "column",
    // 40px top and bottom pushed the Send button under the fold on a laptop.
    // The sides keep their 32px: that is what stops the phone input and the
    // channel cards touching the card edge.
    padding: "26px 32px 30px",
    backgroundColor: "#ffffff",
    boxShadow:
      "0 10px 40px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow:
        "0 20px 50px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08)",
    },
  },
  logo_signin: {
    // The mark is identifying, not the subject of the screen — the sign-in
    // form is. 64px still reads as the brand at arm's length.
    width: "64px",
    height: "64px",
    marginBottom: "14px",
    filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))",
  },
  inputWrapper: {
    position: "relative",
    width: "100%",
    marginBottom: "16px",
  },
  inputIcon: {
    position: "absolute",
    left: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#95a5a6",
    fontSize: "20px",
    pointerEvents: "none",
    zIndex: 1,
    transition: "color 0.3s ease",
  },
  inputWrapperFocused: {
    "& $inputIcon": {
      color: "#017109",
    },
  },
  input: {
    width: "100%",
    height: "48px",
    borderRadius: "8px",
    border: "2px solid #e0e0e0",
    padding: "0 16px 0 48px",
    backgroundColor: "#f8f9fa",
    fontSize: "15px",
    fontFamily: "'Inter', sans-serif",
    fontWeight: 400,
    color: "#2c3e50",
    transition: "all 0.3s ease",
    boxSizing: "border-box",
    "&:focus": {
      outline: "none",
      border: "2px solid #017109",
      backgroundColor: "#ffffff",
      boxShadow: "0 0 0 4px rgba(1, 113, 9, 0.1)",
    },
    "&::placeholder": {
      color: "#95a5a6",
      fontSize: "14px",
    },
  },
  login_button: {
    width: "100%",
    backgroundColor: "#017109",
    color: "#fff",
    padding: "14px 24px",
    borderRadius: "8px",
    border: "none",
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "'Poppins', sans-serif",
    textTransform: "none",
    letterSpacing: "0.5px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 12px rgba(1, 113, 9, 0.2)",
    "&:hover": {
      backgroundColor: "#015a07",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(1, 113, 9, 0.3)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
    "&:disabled": {
      backgroundColor: "#95a5a6",
      cursor: "not-allowed",
      boxShadow: "none",
      opacity: 0.6,
      transform: "none",
      "&:hover": {
        transform: "none",
        backgroundColor: "#95a5a6",
      },
    },
  },
  google_sign_in_button: {
    marginTop: "7px",
    width: "100%",
  },
  password_reset_field: {
    outline: "none",
    borderColor: "#3bb19b",
    borderWidth: "1px",
    width: "90%",
    padding: "15px",
    marginBottom: "10px",
    borderRadius: "10px",
    backgroundColor: "#edf5f3",
    margin: "5px 0",
    fontSize: "14px",
  },
  password_reset_field_error: {
    width: "92%",
    padding: "10px",
    margin: "5px 0",
    backgroundColor: "#f34646",
    color: "white",
    borderRadius: "5px",
    fontSize: "12px",
    textAlign: "center",
    fontStyle: "italic",
    fontWeight: "100",
    marginTop: "-10px",
  },
  reset_button: {
    backgroundColor: "#017109",
    color: "#fff",
    border: "none",
    padding: "15px",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px",
    width: "96%",
    textTransform: "uppercase",
  },
  loadingText: {
    fontSize: "0.7em",
    fontStyle: "italic",
    color: "#0B2559",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  googleSignInLoadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  login_loader: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.7)", // set the background color to white with 70% opacity
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1,
  },
});

export default useStyles;
